import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "external-questionnaire-filter-chips";

const keys = addTranslations(RESOURCE_NAME, {
    label: {
        en: "Filter by:",
        fr: "Filtrer par:",
    },
    assignee_label: {
        en: "Assignee",
        fr: "Personne assignée",
    },
    question_status_filter: {
        en: "Status",
        fr: "Statut",
    },
    ai_answer_status_filter: {
        en: "AI suggested answers",
        fr: "Réponses suggérées par l'IA",
    },
    questionnaire_status_filter: {
        en: "Status",
        fr: "Statut",
    },
    answer_type_filter: {
        en: "Answer type",
        fr: "Type de réponse",
    },
    question_type_single_select: {
        en: "Single select",
        fr: "Sélection unique",
    },
    question_type_multi_select: {
        en: "Multi select",
        fr: "Sélection multiple",
    },
    question_type_text: {
        en: "Text",
        fr: "Texte",
    },
    question_type_number: {
        en: "Number",
        fr: "Nombre",
    },
});

export function useExternalQuestionnaireFilterChipsTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
